import React from "react";
import { Switch, useRouteMatch} from "react-router-dom";
import "./App.css";
import HeaderComponent from "./components/header/headerComponent";
import HomeComponent from "./components/home/homeComponent";
import PrototypeComponent from "./components/prototype/prototypeComponent";
import ProtectedRoute from "./components/privateRoute";
import { toast } from 'react-toastify';

function App() {
  toast.configure();
  const {path} = useRouteMatch();
  return (
    <div className="App">
      <HeaderComponent />
        <Switch>
          <ProtectedRoute path={`${path}`} exact component={HomeComponent} />
          <ProtectedRoute path={`${path}/prototype/create/:id`} component={PrototypeComponent} />
        </Switch>
    </div>
  );
}

export default App;
